import { BrandName } from '@/types';
import { Typography } from 'antd';
import { useEffect, useState } from 'react';
import CustomTable from '../table';

const { Text } = Typography;

interface Props {
  data: BrandName[]; // TODO: change to UserRequest type
  columns: any[]; 
  page: number;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  limit: number;
  setLimit: React.Dispatch<React.SetStateAction<number>>;
  total: number;
  downloadData?: (record: any) => void;
}

export function UserRequestsTable({
  data,
  columns,
  page,
  setPage,
  limit,
  setLimit,
  total,
  downloadData,
}: Props) {
  const [filteredData, setFilteredData] = useState<BrandName[]>([]); // TODO: change to UserRequest type

  useEffect(() => {  // TODO: change to UserRequest type
    if (!data) return;
    const formattedData = data?.map((brandName) => ({
      ...brandName,
      key: brandName?._id,
    }));
    setFilteredData(formattedData); 
  }, [data]);

  return (
    <>
      <div className="tables-info">
        <Text style={{ color: '#9FA1AD', fontWeight: 500 }}>
          {total} Total User Requests
        </Text>
        <span className="tables-divider" />
        <Text style={{ color: '#9FA1AD', fontWeight: 500 }}>
          Updated 20 min ago
        </Text>
      </div>

      <CustomTable
        data={data}
        columns={columns}
        filteredData={filteredData}
        setFilteredData={setFilteredData}
        isDetailed={false}
        isBrandNameStatus
        label="User Requests"
        total={total}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
        downloadData={downloadData}
      />
    </>
  );
}
